import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("li", null, " Если настройка \"Использовать нормативные размеры по типу пакета\" включена, то при импорте или редактировании пакетов подставляются из соотвествующих полей свойста \"тип пакетов\" "),
  /*#__PURE__*/_createElementVNode("li", null, " Поле \"Показывать вкладку отгрузки\" переключает отображение вкладки отгрузки в планах. Также, если настройка выключена, то отгрузки не импортируются и не экспортируются "),
  /*#__PURE__*/_createElementVNode("li", null, " Поле \"Свойство номенклатуры\" устанвливает выбранное свойство для номенклатуры пакетов "),
  /*#__PURE__*/_createElementVNode("li", null, " Поле \"Нормативный отступ в контейнерах\" устанавливает выбранный отступ в контейнерах при импорте "),
  /*#__PURE__*/_createElementVNode("li", null, " Поле \"Нормативное смещение в контейнерах\" устанавливает выбранное смещение в контейнерах при импорте "),
  /*#__PURE__*/_createElementVNode("li", null, " Поле \"Тип марджина\" устанавливает вид марджина в номенклатуре заказов "),
  /*#__PURE__*/_createElementVNode("li", null, " Если настройка \"Использовать отдельный сервер для решателя\" включена, то предлагается ввести новый url сервера для решателя, который будет использоваться "),
  /*#__PURE__*/_createElementVNode("li", null, " Поле \"URL адрес сервера\" устанавливает адрес сервера для решателя, поле активно, только если включено \"Использовать отдельный сервер для решателя\" "),
  /*#__PURE__*/_createElementVNode("li", null, " Кнопка \"Тест соединения\" проводит пробное соединение с указанным сервером для решателя ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoDialog = _resolveComponent("InfoDialog")!

  return (_openBlock(), _createBlock(_component_InfoDialog, {
    title: "Справка: Настройки программы",
    ref: "dialog"
  }, {
    infoForm: _withCtx(({}) => [
      _hoisted_1
    ]),
    _: 1
  }, 512))
}